import { render, staticRenderFns } from "./ServiceOrderView.vue?vue&type=template&id=16f0f0fc&"
import script from "./ServiceOrderView.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports